<template>
  <div class="table-box setTable">
    <div class="table-box">
      <loading :isShow="tableLoading" />
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="productName">
          <div class="text-left">
            {{row.productName}}
            <span class="tag red" v-if="row.isTemplate==0&&templateDetail.id&&!detail.isTop&&detail.id != userInfo.organId">独立费率</span>
            <span class="tag gray" v-if="row.publishStatus==1">已下架</span>
            <span class="tag gray" v-if="row.salesStatus==1">停售</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="insureCost">
          <div>
            {{ row.insureCost }}元起
          </div>
        </template>
        <template slot-scope="{ row }" slot="fee">
          <div :class="{ 'red-text': row.isTemplate == 0 && templateDetail.id && !detail.isTop && detail.id != userInfo.organId }" style="margin-right:0">
            <template v-if="row.min != row.max">
              <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
            </template>
            <span v-else>{{ row.min }}%</span>
          </div>
          <div v-for="(item, index) in row.activityInfoList" :key="index">
            <div class="huo" v-if="(detail.nodeType == 2 || detail.levelCode == 10001)&&item.mode == 1">
              <i>活</i>最高达{{ item.commission }}%
            </div>
            <div v-else-if="detail.isTop && item.mode == 2" class="huo-text">
              <span><i>活</i>梯度活动</span>
            </div>
          </div>
          <div v-if="row.merchantActivity">
            <span style="color: orange">+{{ row.merchantActivity.rewardRate + '%' }}</span>
            <Tooltip>
              <Icon type="ios-help-circle-outline" style="margin-left: 3px;" size="16" />
              <template #content>
                <p>活动时间：{{ row.merchantActivity.startTime | filterTime('YYYY/MM/DD') }}-{{ row.merchantActivity.endTime | filterTime('YYYY/MM/DD') }}</p>
                <p>活动名称：{{ row.merchantActivity.name }}</p>
              </template>
            </Tooltip>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="goRate(row)">查看费率</span>
          <span v-if="organShow && row.organizationId != userInfo.organId"  class="table-btn red"  @click="delProduct(row)">删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center;" />
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import { config } from './noRateProduct2.config.js';
export default {
  mixins: [common, config],
  data(){
    return{
      tableLoading: false, //表格loading
      columns: [],
      templateDetail: {}, //当前选择的组织模板数据
      organShow: true,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 5, //页容量
      pageNum: 1, //当前页
      detail: {}, //当前选择的组织数据
      nodeType:'1'
    }
  },
  methods:{
    // 获取模板详情
    getTemplateDetail() {
      this.$http({
        url: "/buz/organizationTemplate/getTemplate",
        type: "post",
        data: {
          organizationType: this.nodeType,
          organizationId: this.userInfo.organId
        }
      }).then(res => {
        this.templateDetail = res.data || {};
      })
    },
    // 跳转费率表
    goRate(item) {
      this.openPageTabTags(
          '/productResource/fee/rateDetail',
          {
            id: item.organizationId,
            nodeType: this.nodeType,
            productCode: item.productCode,
            isTemplate: item.isTemplate,
            sourceType: item.sourceType,
            publishStatus: item.publishStatus,
            mechanName:this.userInfo.merchantName,
            productName: item.productName,
            companyName: item.companyName,
            organShow:this.organShow,
            workName:'workName',
            pageType: 'merchant',
            showRateTag:this.templateDetail.id,
          }
      );
    },
    // 删除产品
    delProduct(item) {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry("确定删除产品？").then(() => {
        this.$http({
          url: "/buz/productBase/remove/product",
          type: "POST",
          data: {
            organizationId: item.organizationId,
            organizationType: '1',
            productCodes: [item.productCode],
          }
        }).then(res => {
          this.$notice.success("删除产品成功");
          this.searchAjax();
        })
      });
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    // 获取列表数据
    getList() {
      this.tableLoading = true;
      this.$http({
        url: "/buz/organizationProduct/query/page",
        type: "post",
        data: {
          handleSource:2,
          isThereRate:'0',
          organizationId:this.userInfo.organId,
          nodeType:this.nodeType,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
      }).then(res => {
        this.tableLoading = false;
        this.tableData = res.data;
        this.total = res.total;
      }).catch(e => {
        this.tableLoading = false;
      })
    },
  },
  mounted(){
    if(this.userInfo.orgType == '1'){
      this.organShow = false
    }else{
      this.organShow = true
    }
    this.getTemplateDetail()
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.setTable{
  padding-bottom: 10px;
}
.tag {
    display: inline-block;
    line-height: 20px;
    height: 20px;
    border-radius: 4px;
    padding: 0 7px;
    margin-right: 10px;
    &.gray {
      background: #CED1D5;
      border: 1px solid #CED1D5;
      color: #515C6F;
    }
    &.red {
      background: #FFD8C7;
      border: 1px solid #FFD8C7;
      color: #FF7134;
    }
  }
</style>